<app-header></app-header>
<ion-content
  scroll-y="false"
  force-overscroll="true"
  class="order-status-content"
  [class.android-tablet-fix]="isAndroidTablet()"
>
  <div
    id="desktop"
    *ngIf="(this.platformService?.isTouchExperience$ | async) !== null && (this.platformService?.isTouchExperience$ | async) === false"
  >
    <cdk-virtual-scroll-viewport
      class="cdk-scroll-desktop-my-orders"
      orientation="vertical"
      itemSize="87"
      minBufferPx="1000"
      maxBufferPx="2000"
    >
      <div class="top-section-background">
        <ion-grid [fixed]="true">
          <ion-row>
            <ion-col>
              <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
            </ion-col>
            <ion-col class="right-align-column">
              <ng-container>
                <ion-button
                  class="btn-download"
                  data-cy="download-order-button"
                  (click)="showDownloadOrdersModal(true)"
                  fill="clear"
                >
                  <ion-icon name="download-outline"></ion-icon>
                  {{ 'i18n.orderPage.download' | translate }}
                </ion-button>
              </ng-container>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <div class="header-section">
                <h1 data-cy="usf-filtering-banner-title-text">
                  {{ 'i18n.orderStatusPage.orderStatus' | translate | uppercase
                  }}
                </h1>
                <div class="my-orders-toggle">
                  <ion-button
                    class="inactive-view-button"
                    data-cy="my-orders-view-page-button"
                    (click)="routeTo('my-orders-view')"
                  >
                    <ion-label>
                      {{'i18n.orderStatusPage.myOrders' | translate}}
                    </ion-label>
                  </ion-button>

                  <ion-button
                    class="active-view-button"
                    data-cy="order-status-page-button"
                  >
                    <ion-label>
                      {{'i18n.orderStatusPage.orderStatus' | translate}}
                    </ion-label>
                  </ion-button>
                </div>
              </div>
            </ion-col>
          </ion-row>

          <ion-row>
            <ion-col>
              <app-usf-filtering-banner-desktop
                [isLoading]="false"
                [quickFilters]="myOrders?.quickFilters"
                [numberOfSelectedFilters]="numberOfSelectedFilters"
                (filterClicked)="openFilterModal()"
                [showQuickDateFilterOption]="true"
                [showResetFilterOption]="false"
                (changeDateFilterClicked)="openFilterModal(true)"
                (quickFiltersClicked)="toggleStatusFilter($event)"
                [filterDateRange]="deliveryDateRange"
              ></app-usf-filtering-banner-desktop>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
      <div class="bottom-section-background">
        <ion-grid [fixed]="true">
          <div
            class="no-orders"
            *ngIf="!!myOrders?.myOrdersRows && myOrders?.myOrdersRows.length === 0"
            data-cy="no-orders-message"
          >
            {{'i18n.orderStatusPage.noOrdersMsg' | translate}}
          </div>

          <app-orders-list-desktop
            [ordersList]="myOrders"
          ></app-orders-list-desktop>
        </ion-grid>
      </div>
      <div class="footer-wrapper">
        <app-footer></app-footer>
      </div>
    </cdk-virtual-scroll-viewport>
  </div>

  <!-- TOUCH EXPERIENCE -->
  <ng-container
    *ngIf="(this.platformService?.isTouchExperience$ | async) !== null && (this.platformService?.isTouchExperience$ | async) === true"
  >
    <ng-container *ngIf="hideRefresher === false">
      <ion-refresher
        slot="fixed"
        [pullFactor]="1"
        [pullMin]="50"
        [pullMax]="900"
        (ionRefresh)="handleRefresh($event)"
      >
        <ion-refresher-content
          pullingIcon="chevron-down"
          pullingText=""
          refreshingSpinner="circles"
          refreshingText=""
        >
        </ion-refresher-content>
      </ion-refresher>
    </ng-container>
    <ng-container
      *ngIf="platformService?.platformType === platformService?.platformEnum?.tablet"
    >
      <!-- TABLET -->
      <div class="container" [class.ios-container]="isIOS">
        <div
          class="bottom-section-background-touch"
          [class.ios-section]="isIOS"
        >
          <cdk-virtual-scroll-viewport
            #tabletVirtualScroll
            class="cdk-scroll-touch"
            [class.cdk-scroll-ios-tablet]="isIOS"
            orientation="vertical"
            appCustomVs
            [itemHeights]="myOrders?.itemHeights"
            [indexOffset]="0"
            [bufferBefore]="50"
            [bufferAfter]="50"
          >
            <div
              class="header-section"
              [class.tablet]="platformService?.platformType === platformService?.platformEnum?.tablet"
            >
              <h1 data-cy="usf-filtering-banner-title-text">
                {{ 'i18n.orderStatusPage.orderStatus' | translate | uppercase }}
              </h1>

              <div class="header-button-sections tablet">
                <ng-container>
                  <ion-button
                    class="btn-download"
                    data-cy="download-order-button"
                    (click)="showDownloadOrdersModal(true)"
                    fill="clear"
                  >
                    <ion-icon name="download-outline"></ion-icon>
                    {{ 'i18n.orderPage.download' | translate }}
                  </ion-button>
                </ng-container>
                <div class="my-orders-toggle">
                  <ion-button
                    class="inactive-view-button"
                    data-cy="my-orders-view-page-button"
                    (click)="routeTo('my-orders-view')"
                  >
                    <ion-label>
                      {{'i18n.orderStatusPage.myOrders' | translate}}
                    </ion-label>
                  </ion-button>

                  <ion-button
                    class="active-view-button"
                    data-cy="order-status-page-button"
                  >
                    <ion-label>
                      {{'i18n.orderStatusPage.orderStatus' | translate}}
                    </ion-label>
                  </ion-button>
                </div>
              </div>
            </div>
            <app-usf-filtering-banner-tablet
              [isLoading]="false"
              [quickFilters]="myOrders?.quickFilters"
              [numberOfSelectedFilters]="numberOfSelectedFilters"
              (filterClicked)="openFilterModal()"
              [showQuickDateFilterOption]="true"
              [showResetFilterOption]="false"
              (changeDateFilterClicked)="openFilterModal(true)"
              (quickFiltersClicked)="toggleStatusFilter($event)"
              [filterDateRange]="deliveryDateRange"
            ></app-usf-filtering-banner-tablet>

            <div
              class="no-orders"
              *ngIf="!!myOrders?.myOrdersRows && myOrders?.myOrdersRows.length === 0"
              data-cy="no-orders-message"
            >
              {{'i18n.orderStatusPage.noOrdersMsg' | translate}}
            </div>
            <app-orders-list-tablet
              [ordersList]="myOrders"
            ></app-orders-list-tablet>
          </cdk-virtual-scroll-viewport>
        </div>
      </div>
    </ng-container>

    <ng-container
      *ngIf="platformService?.platformType === platformService?.platformEnum?.mobile"
    >
      <!-- MOBILE -->
      <div class="container">
        <div class="bottom-section-background-touch">
          <cdk-virtual-scroll-viewport
            #mobileVirtualScroll
            class="cdk-scroll-touch cdk-scroll-mobile"
            orientation="vertical"
            appCustomVs
            [itemHeights]="myOrders?.itemHeights"
            [indexOffset]="0"
            [bufferBefore]="50"
            [bufferAfter]="50"
          >
            <div class="mobile-header">
              <div class="header-button-sections">
                <div class="my-orders-toggle">
                  <ion-button
                    class="inactive-view-button"
                    (click)="routeTo('my-orders-view')"
                    data-cy="my-orders-view-page-button"
                  >
                    <ion-label>
                      {{'i18n.orderStatusPage.myOrders' | translate}}
                    </ion-label>
                  </ion-button>

                  <ion-button
                    class="active-view-button"
                    data-cy="order-status-page-button"
                  >
                    <ion-label>
                      {{'i18n.orderStatusPage.orderStatus' | translate}}
                    </ion-label>
                  </ion-button>
                </div>
                <ion-icon
                  class="additional-info-ellipsis"
                  data-cy="additional-info-ellipsis-icon"
                  name="ellipsis-vertical-circle-sharp"
                  (click)="showDownloadOrdersActionSheet(true)"
                ></ion-icon>
              </div>
            </div>

            <app-usf-filtering-banner-mobile
              [isLoading]="false"
              [quickFilters]="myOrders?.quickFilters"
              [numberOfSelectedFilters]="numberOfSelectedFilters"
              (filterClicked)="openFilterModal()"
              [showQuickDateFilterOption]="true"
              [showResetFilterOption]="false"
              (changeDateFilterClicked)="openFilterModal(true)"
              (quickFiltersClicked)="toggleStatusFilter($event)"
              [filterDateRange]="deliveryDateRange"
            ></app-usf-filtering-banner-mobile>

            <div
              class="no-orders"
              *ngIf="!!myOrders?.myOrdersRows && myOrders?.myOrdersRows.length === 0"
              data-cy="no-orders-message"
            >
              {{'i18n.orderStatusPage.noOrdersMsg' | translate}}
            </div>
            <app-orders-list-mobile
              [ordersList]="myOrders"
            ></app-orders-list-mobile>
          </cdk-virtual-scroll-viewport>
        </div>
      </div>
    </ng-container>
  </ng-container>
  <ion-action-sheet
    class="action-sheet-touch"
    mode="ios"
    [isOpen]="(downloadOrdersActionSheetIsOpen$ | async) !== null && (downloadOrdersActionSheetIsOpen$ | async)"
    (didDismiss)="showDownloadOrdersActionSheet(false)"
    [buttons]="downloadOrdersActionSheetButtons"
  ></ion-action-sheet>
</ion-content>

<div
  class="create-button-wrapper"
  *ngIf="(this.platformService?.isTouchExperience$ | async) !== null && (this.platformService?.isTouchExperience$ | async) === true"
>
  <ion-button
    id="create-new-order-btn"
    class="usf-fill-green-mobile-modal-button"
    data-cy="create-new-order-button"
    (click)="createNewOrder()"
  >
    {{'i18n.orderStatusPage.createNewOrderButton' | translate}}
  </ion-button>
</div>

<!-- FLOATING TOOLTIP FOR MY ORDERS -->
<div class="help-icon">
  <img
    data-cy="my-orders-page-open-help-modal-button"
    src="assets/icon/custom-help-tooltip.svg"
    (click)="openHelpModal()"
  />
</div>

<div data-cy="order-status-top-button-section" class="top-button">
  <ion-button
    data-cy="order-status-top-button"
    class="usf-fill-green-button"
    (click)="goToTop()"
  >
    {{ 'i18n.common.top' | translate }}&nbsp;
    <ion-icon
      data-cy="order-status-top-button-icon"
      name="chevron-up-circle-outline"
    ></ion-icon>
  </ion-button>
</div>

<ion-modal
  [ngClass]="(platformService?.isTouchExperience$ | async) !== null && (platformService?.isTouchExperience$ | async) ? 'ion-modal-touch' : 'modal-desktop-size-lg'"
  [initialBreakpoint]="platformService.platformType !== platformService.platformEnum.desktop ? 1 : undefined"
  [breakpoints]="platformService.platformType !== platformService.platformEnum.desktop  ? [0, 0.5, 1] : undefined"
  [isOpen]="(downloadOrdersModalIsOpen$ | async) !== null && (downloadOrdersModalIsOpen$ | async)"
  (ionModalDidDismiss)="showDownloadOrdersModal(false)"
>
  <ng-template>
    <app-simple-download-orders-modal
      class="ion-page"
      [orders]="(orders$ | async) !== null ? (orders$ | async) : []"
      [fileTypes]="downloadOrdersFileTypes"
      [platform]="platformService.platformType"
      (dismissEvent)="showDownloadOrdersModal(false)"
      (downloadOrdersEmitter)="handleDownloadOrders($event)"
      fileName="Order_Status_{{today | date: 'MMddyyyy'}}"
      [showOrdersDropdown]="false"
    >
    </app-simple-download-orders-modal>
  </ng-template>
</ion-modal>
